// @ts-nocheck

import PropTypes from 'prop-types'
import React from 'react'

import { Icon } from '../Icon'

const renderIcon = (props) => {
  const {
    iconName,
    iconFill,
    iconPosition = 'left',
    iconSize = 20,
    renderCustomIcon
  } = props

  const iconStyles =
    iconPosition === 'left'
      ? { marginRight: 10, height: iconSize }
      : { marginLeft: 10, height: iconSize }

  if (renderCustomIcon) return renderCustomIcon()

  return (
    <div style={iconStyles}>
      <Icon name={iconName} fill={iconFill} size={iconSize} />
    </div>
  )
}

const renderText = (props) => {
  const { boldText, text, textFill } = props

  return (
    <div>
      {(boldText || boldText === 0) && (
        <span style={{ ...styles.boldText, color: textFill }}>
          {`${boldText} `}
        </span>
      )}
      <span style={{ color: textFill }}>{text}</span>
    </div>
  )
}

/**
@description Renders an icon and label

@param {string} boldText. Bold text to be displayed. Can be empty.

@param {string} iconFill. The colour of the icon.

@param {string} iconName. The icon name. See Icon for valid
icon names.

@param {string} iconPosition. Sets the icon position relative
to the text. Can be either left or right. Is left by default.

@param {number} iconSize. Sets the size of the icon.

@param {node} label. Allows components to be passed in to display
next to the icon, e.g. multiline html.

@param {function} renderCustomIcon. Render function. Allows customised
icons to be rendered.

@param {string} text. Normal text to be displayed

@param {string} textFill. Colour of the text/bold text. Can be left blank.

@returns {function} LabelIcon.
*/

export default function LabelIcon(props) {
  const {
    iconName,
    iconPosition = 'left',
    label,
    renderCustomIcon,
    text
  } = props

  return (
    <div style={styles.wrapper}>
      {iconPosition === 'left' &&
        (iconName || renderCustomIcon) &&
        renderIcon(props)}
      {label}
      {text && renderText(props)}
      {iconPosition === 'right' &&
        (iconName || renderCustomIcon) &&
        renderIcon(props)}
    </div>
  )
}

LabelIcon.propTypes = {
  boldText: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  iconFill: PropTypes.string,
  iconName: PropTypes.string,
  iconPosition: PropTypes.string,
  iconSize: PropTypes.number,
  label: PropTypes.node,
  renderCustomIcon: PropTypes.func,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  textFill: PropTypes.string
}

const styles = {
  boldText: {
    fontWeight: 700
  },
  wrapper: {
    display: 'flex',
    alignItems: 'center'
  }
}
